// GSBS Authentication Configuration
// Centralized authentication service configuration

export const AUTH_CONFIG = {
  // Auth service base URL
  AUTH_SERVICE_URL: process.env.REACT_APP_AUTH_SERVICE_URL || 'https://auth.gsbooks.org',
  
  // Cookie name for JWT token (should match auth service)
  AUTH_COOKIE_NAME: process.env.REACT_APP_AUTH_COOKIE_NAME || 'jwt_token',
  
  // Allowed domains for authentication
  ALLOWED_DOMAINS: ['gsbooks.org', '.gsbooks.org'],
  
  // Auth endpoints
  ENDPOINTS: {
    STATUS: '/auth/status',
    LOGIN: '/auth/google',
    LOGOUT: '/logout',
    INFO: '/auth/info',
    HEALTH: '/health'
  }
};

// Helper function to check if current domain is allowed
export const isAllowedDomain = () => {
  const hostname = window.location.hostname;
  return AUTH_CONFIG.ALLOWED_DOMAINS.some(domain => {
    if (domain.startsWith('.')) {
      return hostname === domain.slice(1) || hostname.endsWith(domain);
    }
    return hostname === domain;
  });
};

// Helper function to get full auth URL
export const getAuthUrl = (endpoint) => {
  return `${AUTH_CONFIG.AUTH_SERVICE_URL}${endpoint}`;
};

export default AUTH_CONFIG; 